<template>
  <v-container fluid class="item-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/item/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="items-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="headers"
              :items="[
                ...items.filter(item=>item.itemstatus=='Active' && item.itemtype=='Item'),
                ...items.filter(item=>item.itemstatus=='Active' && item.itemtype=='Other Item'), 
                ...items.filter(item=>item.itemstatus!=='Active'),
              ]"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Item?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteitem.itemname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteitem)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.itemimage" size="50">
                  <img v-bind:src="item.itemimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="50">
                  <span class="white--text headline">{{ item.itemname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.itemgroupid="{ item }">
                <p class="two-line">
                  <span v-if="item.brandid">{{ brands.length>0 ? brands.find(brand=>brand._id == item.brandid)['brandname'] : ''  }}</span> 
                </p>
                <p class="two-line">
                  <span v-if="item.itemgroupid">{{ itemgroups.length>0 ? itemgroups.find(group=>group._id == item.itemgroupid)['itemgroupname'] : ''  }}&nbsp;-&nbsp;</span> 
                  <span v-if="item.itemcategoryid">{{ itemcategories.length>0 ? itemcategories.find(category=>category._id == item.itemcategoryid)['itemcategoryname'] : ''  }}</span>
                </p>
                </template>
              <template v-slot:item.itemname="{ item }">
                <a class="primaryConst--text">{{ item.itemname }}</a>
              </template>
              <!-- <template v-slot:item.prices="{ item }">
                <table v-if="item.prices!==undefined && item.prices.length>0">
                  <tr v-for="(price) in item.prices" v-bind:key="price._id">
                    <td><p class="two-line" style="width: 110px; margin-right: 10px;">{{  price.pricename + ' ' + price.listprice }} </p></td>
                    <td><p class="two-line" style="width: 90px; margin-right: 10px;">Qty {{  price.minqty + '-' + price.maxqty }} </p></td>
                    <td v-if="price.foc.enable==true && price.foc.itemqty && price.foc.getitemqty"><p class="two-line" style="margin-left: 10px;">Buy {{  price.foc.itemqty }} Get {{ price.foc.getitemqty.toFixed(2) }}</p></td>
                  </tr>
                </table>  
              </template> -->
              <template v-slot:item.itemid="{ item }">
                {{ item.itemid }}
              </template>
              <template v-slot:item.itemunit="{ item }">
                <p class="two-line">1 {{ item.itemunit }}  = {{ item.itemconvert }} {{ item.itemunit2 }}</p>
                <p class="two-line">{{ item.itemsize }}</p>
              </template>
              <template v-slot:item.itemstatus="{ item }">
                <v-chip :color="
                  item.itemstatus=='Active' ? 'success white--text' :
                  item.itemstatus=='Inactive' ? 'greyTint white--text' : 
                  'secondaryConst white--text'" small>
                  {{ item.itemstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn v-if="item.itemstatus!='Active'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ItemList',
  data() {
    return {
      snackbar: null,
      dialog: false,
      deleteitem: {},
      headers: [
        { text: 'Image', value: 'image', width: '5%', sortable: false },
        { text: 'Name', value: 'itemname', width: '30%' },
        { text: 'Brand & Category', value: 'itemgroupid', width: '35%'},
        { text: 'Size & Unit', value: 'itemunit', width: '20%' },
        { text: 'Status', value: 'itemstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
    };
  },
  computed: {
    ...mapState('Item', ['items', 'isReceiving', 'isDeleting', 'idToDelete', 'itemsMessage', 'isUpdating']),
    ...mapState('Brand', ['brands']),
    ...mapState('ItemCategory', ['itemcategories']),
    ...mapState('ItemGroup', ['itemgroups']),
  },
  methods: {
    ...mapActions('Item', ["getItemsRequest","deleteItemRequest","updateItemRequest","createItemRequest"]),
    ...mapActions('Brand', ["getBrandsRequest"]),
    ...mapActions('ItemCategory', ["getItemCategoriesRequest"]),
    ...mapActions('ItemGroup', ["getItemGroupsRequest"]),
    deleteItem(item) {
      this.deleteItemRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteitem = {
        _id: item._id,
        itemname: item.itemname,
      }
    },
    editItem(item) {
      this.$router.push({ name: 'ItemEdit', params: item })
    },

  },
  async created () {
    await this.getItemsRequest();
    if(this.itemcategories.length==0) await this.getItemCategoriesRequest();
    if(this.itemgroups.length==0) await this.getItemGroupsRequest();
    if(this.brands.length==0) await this.getBrandsRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
